"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResponsiveImage = exports.default = exports.Image = exports.AmbientVideo = void 0;
var _react = require("react");
var _reactSvg = require("react-svg");
var _analytics = _interopRequireWildcard(require("../analytics"));
var _breakpoints = require("../breakpoints");
var _index = _interopRequireDefault(require("./index.styled"));
var _MediaDisclaimer = _interopRequireDefault(require("./MediaDisclaimer"));
var _pause = _interopRequireDefault(require("./pause.svg"));
var _play = _interopRequireDefault(require("./play.svg"));
var _useAmbientVideoControls = require("./useAmbientVideoControls");
var _jsxRuntime = require("react/jsx-runtime");
const useResponsiveImage = function () {
  const breakpoints = {
    mobile: (0, _breakpoints.useMobileBreakpoint)(),
    tablet: (0, _breakpoints.useTabletBreakpoint)(),
    desktop: (0, _breakpoints.useDesktopBreakpoint)({
      up: true
    })
  };
  const getImage = function (_ref) {
    let {
      mobile = undefined,
      tablet = undefined,
      desktop = undefined
    } = _ref;
    let image = {};
    if (breakpoints.desktop === true) {
      image = desktop || tablet || mobile;
    } else if (breakpoints.tablet === true) {
      image = tablet || desktop || mobile;
    } else if (breakpoints.mobile === true) {
      image = mobile || tablet || desktop;
    }
    return image || {};
  };
  return getImage;
};
exports.useResponsiveImage = useResponsiveImage;
const PlayPause = function (_ref2) {
  let {
    isShowingVideo,
    ...props
  } = _ref2;
  const fireAnalytics = (0, _analytics.default)("AmbientVideo", {
    isShowingVideo: !isShowingVideo
  });
  const handleOnClick = function () {
    fireAnalytics("onAmbientVideoPlayToggle");
    if (typeof (props === null || props === void 0 ? void 0 : props.onClick) === "function") {
      props.onClick();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.PlayPause, {
    ...props,
    onClick: handleOnClick,
    "data-testid": "PlayPause"
  });
};
const AmbientVideo = function (_ref3) {
  let {
    ambientVideo,
    ambientVideoMobile,
    fullscreen,
    posterImage
  } = _ref3;
  const getImage = useResponsiveImage();
  const {
    disclaimer,
    tooltip
  } = getImage(posterImage);
  const isMobile = (0, _breakpoints.useMobileBreakpoint)();
  const mp4 = isMobile && ambientVideoMobile ? ambientVideoMobile.mp4 : ambientVideo.mp4;
  const webm = isMobile && ambientVideoMobile ? ambientVideoMobile.webm : ambientVideo.webm;
  const videoDisclaimer = isMobile && ambientVideoMobile ? ambientVideoMobile.disclaimer : ambientVideo.disclaimer;
  const {
    autoPlay,
    ref,
    setAutoPlay
  } = (0, _useAmbientVideoControls.useAmbientVideoControls)();
  const posterDisclaimer = disclaimer ? {
    tooltip,
    ...disclaimer
  } : undefined;
  const disclaimerProps = autoPlay ? videoDisclaimer : posterDisclaimer;
  const [isVideoLoaded, setIsVideoLoaded] = (0, _react.useState)(false);
  const [failedVideoLoad, setFailedVideoLoad] = (0, _react.useState)(false);
  const handleError = function () {
    if (!failedVideoLoad) {
      setFailedVideoLoad(true);
    }
  };
  const handleVideoLoaded = function () {
    if (!isVideoLoaded) {
      setIsVideoLoaded(true);
    }
  };
  const shouldRenderSource = autoPlay || isVideoLoaded;
  const altText = `${autoPlay ? "Pause video" : "Play video"}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.BackgroundVideo, {
        playsInline: true,
        autoPlay: autoPlay,
        $show: autoPlay,
        muted: true,
        loop: true,
        "aria-hidden": true,
        onCanPlayThrough: handleVideoLoaded,
        onCanPlay: handleVideoLoaded,
        onError: handleError,
        isMobile: isMobile,
        ref: ref,
        children: [webm && shouldRenderSource && /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          src: webm,
          type: "video/webm"
        }), mp4 && shouldRenderSource && /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          src: mp4,
          type: "video/mp4"
        })]
      }, `${webm}${mp4}`), disclaimerProps && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaDisclaimer.default, {
        ...disclaimerProps,
        fullscreen: fullscreen
      })]
    }), !failedVideoLoad && /*#__PURE__*/(0, _jsxRuntime.jsx)(PlayPause, {
      onClick: function () {
        return setAutoPlay(!autoPlay);
      },
      isShowingVideo: autoPlay,
      "aria-label": altText,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSvg.ReactSVG, {
        src: autoPlay ? _pause.default : _play.default,
        beforeInjection: function (svg) {
          svg.setAttribute("aria-hidden", true);
        }
      })
    })]
  });
};
exports.AmbientVideo = AmbientVideo;
function getScene7Size() {
  var _values, _values2;
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (str.indexOf("http") !== 0 && (str.indexOf("hei") === -1 || str.indexOf("wid") === -1)) {
    return {};
  }
  let values;
  try {
    values = new URL(str).searchParams;
  } catch (e) {
    return {};
  }
  return {
    height: (_values = values) === null || _values === void 0 ? void 0 : _values.get("hei"),
    width: (_values2 = values) === null || _values2 === void 0 ? void 0 : _values2.get("wid")
  };
}
const Image = function (_ref4) {
  let {
    image = {},
    ambientVideo,
    ambientVideoMobile,
    children,
    showDisclaimer = true,
    ...props
  } = _ref4;
  const getImage = useResponsiveImage();
  const {
    disclaimer,
    errorSrc,
    tooltip,
    ...imgProps
  } = getImage(image);
  const isMobile = (0, _breakpoints.useMobileBreakpoint)();
  const hasAmbientVideo = ambientVideo && !isMobile || ambientVideoMobile;
  const sizes = getScene7Size(imgProps.src);
  const onErrorAttempt = (0, _react.useRef)(false);
  const onError = function (e) {
    var _imgProps$onError;
    const tried = onErrorAttempt.current;
    if (tried) {
      return;
    }
    imgProps === null || imgProps === void 0 ? void 0 : (_imgProps$onError = imgProps.onError) === null || _imgProps$onError === void 0 ? void 0 : _imgProps$onError.call(imgProps);
    e.target.onerror = undefined;
    e.target.src = errorSrc || (image === null || image === void 0 ? void 0 : image.defaultErrorSrc) || "";
    onErrorAttempt.current = true;
  };
  if (!imgProps.alt) {
    imgProps.alt = "";
    imgProps.role = "presentation";
  }

  // Will hide disclaimer of still if there is ambient video with disclaimer
  const hasAmbientVideoDisclaimer = (ambientVideo === null || ambientVideo === void 0 ? void 0 : ambientVideo.disclaimer) && !isMobile || (ambientVideoMobile === null || ambientVideoMobile === void 0 ? void 0 : ambientVideoMobile.disclaimer);
  const shouldShowDisclaimer = showDisclaimer && !(hasAmbientVideo && hasAmbientVideoDisclaimer);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Image, {
    ...props,
    "data-testid": "Image",
    children: [children && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.NestedContent, {
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.ImgDom, {
      ...imgProps,
      loading: image !== null && image !== void 0 && image.eagerLoad ? "eager" : "lazy",
      ...sizes,
      fullscreen: props.fullscreen,
      onError: onError
    }), shouldShowDisclaimer && (tooltip || disclaimer) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaDisclaimer.default, {
      ...disclaimer,
      tooltip: tooltip,
      fullscreen: props.fullscreen
    }), hasAmbientVideo && /*#__PURE__*/(0, _jsxRuntime.jsx)(AmbientVideo, {
      ambientVideo: ambientVideo,
      ambientVideoMobile: ambientVideoMobile,
      fullscreen: props.fullscreen,
      posterImage: image,
      sizes: sizes
    })]
  });
};
exports.Image = Image;
var _default = exports.default = (0, _analytics.withAnalytics)(Image)({});